import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ParametreGeneral } from '../model/ParametreGeneral';

@Injectable({
  providedIn: "root"
})
export class ParametreGeneralService {
  constructor(private _restClientService: RestClientService) {}

  getAllParametreGeneral() {
    return this._restClientService.load<ParametreGeneral[]>(
      "parametre-generale/get"
    );
  }

  getParametreGeneralById(ferieId) {
    return this._restClientService.load<ParametreGeneral>(
      "parametre-generale/get/" + ferieId
    );
  }

  add(parametreGeneral) {
    return this._restClientService.save<ParametreGeneral>(
      "parametre-generale/add",
      parametreGeneral
    );
  }

  update(parametreGeneral) {
    return this._restClientService.put<ParametreGeneral>(
      `parametre-generale/update`,
      parametreGeneral
    );
  }

  delete(id) {
    return this._restClientService.delete<any>(
      "parametre-generale/delete/" + id
    );
  }
}
